import { MessageButton } from './MessageButton';
import { MessageCheckboxes } from './MessageCheckboxes';
import { MessageDropdown } from './MessageDropdown';
import { MessageRadios } from './MessageRadios';
/**
 * Custom markdown components registered with @airia/ui ChatMarkdown so the
 * agent's interactive picker tags render as real UI instead of raw text.
 * Mirrors the relevant subset of airia-platform's omniCustomMarkdownComponents.
 *
 * All four tags are in @airia/ui 3.x's `MarkdownCustomTag` enum, so the
 * library's customTagsPlugin extracts them automatically and routes through
 * this map by tag name when `enableCustomTags: true`.
 *
 * Pair with `<AddinChatActionsProvider>` higher in the tree so the buttons
 * can submit messages through AddinChat's pipeline.
 */
// biome-ignore lint/suspicious/noExplicitAny: ChatMarkdown's components prop is loosely typed
export const customMarkdownComponents = {
    airiaMessageButton: MessageButton,
    airiaMessageDropdown: MessageDropdown,
    airiaMessageCheckboxes: MessageCheckboxes,
    airiaMessageRadios: MessageRadios,
};
